/* template */
<template minapp="mpx" xlang="wxml"><div class="es-train-information"><div class="es-train-information-item"><div class="es-train-info-date">{{ startTime.date }} {{ startTime.week }}</div><div class="es-train-info-time">{{ startTime.time }}</div><div class="es-train-station-name">{{ fromStationName }}<mpx-image :style='["width: 12px; height: 12px; margin-left: 2px"] | transRpxStyle' :src="(isStartStation ? 'https://pt-starimg.didistatic.com/static/starimg/img/YxaFxD0mks1646826526250.png' : 'https://pt-starimg.didistatic.com/static/starimg/img/yoewm9HxNV1646825268816.png')"/></div></div><div :style='["align-items: center;"] | transRpxStyle' class="es-train-information-item"><div class="es-train-code">{{ trainCode }}</div><mpx-view @tap="onClick" class="es-train-info">时刻表</mpx-view><div class="es-train-info-travel-time">{{ travelTime }}</div></div><div :style='["text-align: right"] | transRpxStyle' class="es-train-information-item"><div class="es-train-info-date">{{ endTime.date }} {{ endTime.week }}</div><div class="es-train-info-time">{{ endTime.time }}</div><div :style='["justify-content: flex-end"] | transRpxStyle' class="es-train-station-name"><mpx-image :style='["width: 12px; height: 12px; margin-right: 2px"] | transRpxStyle' :src="(isEndStation ? 'https://pt-starimg.didistatic.com/static/starimg/img/VUyQ5LqzAi1646826526234.png' : 'https://pt-starimg.didistatic.com/static/starimg/img/yoewm9HxNV1646825268816.png')"/>{{ toStationName }}</div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m791c59ca"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-train-information
    display flex
    justify-content space-between
    .es-train-information-item
      display flex
      flex-direction column
      justify-content space-between
      min-width 70px
      .es-train-info-date, .es-train-info-travel-time
        font-size 13px
        color $train-color-666
      .es-train-info-time
        font-size 24px
        color $train-color-333
        font-weight 700
      .es-train-code, .es-train-station-name
        font-size 13px
        color $train-color-333
        display flex
        align-items center
        font-weight 600
      // .silent
      //   background RGB(20, 115, 255, 0.1)
      //   border-radius 2px
      //   width 12px
      //   height 12px
      //   line-height 10px
      //   text-align center
      //   align-self center
      //   box-sizing border-box
      //   margin-left 2px
      .es-train-info
        position relative
        width 68px
        height 20px
        color #3C5A86
        font-size 13px
        border-radius 8px
        text-align center
        line-height 20px
        margin-bottom 0.5px
        &::after
          position absolute
          content: ""
          width 200%
          height 200%
          box-sizing border-box
          border 1px solid #3C5A86
          transform-origin 0 0
          transform scale(0.5)
          border-radius 16px
          top 0
          left 0
      .es-train-divider
        border-bottom 1px solid #CAD0DA
        width 100%
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m791c59ca"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex791c59ca%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex791c59ca%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m791c59ca"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index791c59ca/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
